import { render } from "./HeaderMenu.vue?vue&type=template&id=eb767a12&scoped=true"
const script = {}

import "./HeaderMenu.vue?vue&type=style&index=0&id=eb767a12&scoped=true&lang=scss"

import exportComponent from "D:\\frontend\\finans\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb767a12"]])

export default __exports__